import React from 'react';
import ProductOrderPayedSelectProperties from "./ProductOrderPayedSelectProperties";
import SelectOption from "../../../ui_components/Select/SelectOption";
import Select from "../../../ui_components/Select/Select";
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const ProductOrderPayedSelect: React.FC<ProductOrderPayedSelectProperties> = ({
                                                                        selected,
                                                                        label = '',
                                                                        onChange,
                                                                        disabled,
                                                                        fullWidth = false,
                                                                        className = '',
                                                                        error
                                                                    }) => {

    const opt = [
        new SelectOption("Pagada", 'true', "Orden pagada", AttachMoneyIcon),
        new SelectOption("Sin pagar", "false", "Orden sin pagar", MoneyOffIcon)
    ]

    const selectedOption = opt.find(t => t.value === selected);

    const onStatusChange = (option: SelectOption) => {
        onChange(option.value)
    }

    return (
        <Select
            error={error}
            className={className}
            disabled={disabled}
            fullWidth={fullWidth}
            label={label && label !== '' ? label : "Pago"}
            placeholder={"Seleccione"}
            selected={selectedOption}
            icon={AttachMoneyIcon}
            onChange={onStatusChange}
            elements={opt}
            showClearButton={true}
        />
    )
}


export default ProductOrderPayedSelect;